<div class="blade-wrapper">
    <div class="blade-header" *ngIf="!showInDialog || (showInDialog && hasToolbar)">
      <div           class="blade-tools">
          <app-toolbar [toolbar]="toolbar">
              <ng-template 
                toolbarToolDef="create_inventory" let-tool>
                <ng-container  *ngIf="tool.hasButtonsToShow">
                <button mat-button
                        data-cy="button"
                        class="datex-button"
                        [disabled]="tool.control.readOnly || tool.control.disabled"
                        [ngStyle]="tool.control.styles.style"
                        [ngClass]="tool.control.styles.classes"
                        [matTooltip]="tool.control.tooltip"
                        matTooltipClass="datex-control-tooltip"
                        (click)="on_create_inventory_clicked($event)"
                        >
                  <div class="button-label">
                    <ng-container *ngIf="tool.control.icon === 'datex-default-spinner'; else showIcon">
                      <div class="button-icon">
                        <i data-cy="button-icon" class="datex-default-spinner"></i>
                      </div>
                    </ng-container>
                    <ng-template #showIcon>
                      <div class="button-icon">
                        <i data-cy="button-icon" class="icon {{tool.control.icon}}"></i>
                      </div>
                    </ng-template>
                    <div data-cy="button-label" class="button-text">{{tool.control.label}}</div>
                  </div>
                
                </button>
                </ng-container>
              </ng-template>
              <ng-template 
                toolbarToolDef="import_inventory" let-tool>
                <ng-container  *ngIf="tool.hasButtonsToShow">
                <button mat-button
                        data-cy="button"
                        class="datex-button"
                        [disabled]="tool.control.readOnly || tool.control.disabled"
                        [ngStyle]="tool.control.styles.style"
                        [ngClass]="tool.control.styles.classes"
                        [matTooltip]="tool.control.tooltip"
                        matTooltipClass="datex-control-tooltip"
                        (click)="on_import_inventory_clicked($event)"
                        >
                  <div class="button-label">
                    <ng-container *ngIf="tool.control.icon === 'datex-default-spinner'; else showIcon">
                      <div class="button-icon">
                        <i data-cy="button-icon" class="datex-default-spinner"></i>
                      </div>
                    </ng-container>
                    <ng-template #showIcon>
                      <div class="button-icon">
                        <i data-cy="button-icon" class="icon {{tool.control.icon}}"></i>
                      </div>
                    </ng-template>
                    <div data-cy="button-label" class="button-text">{{tool.control.label}}</div>
                  </div>
                
                </button>
                </ng-container>
              </ng-template>
              <ng-template 
                toolbarToolDef="separator1" let-tool>
                <ng-container  *ngIf="tool.hasButtonsToShow">
                <div class="tool-separator"></div>
                </ng-container>
              </ng-template>
              <ng-template 
                toolbarToolDef="Manager" let-tool>
                <ng-container  *ngIf="tool.hasButtonsToShow">
                <button mat-button 
                        data-cy="splitbutton"
                        class="datex-button splitbutton" 
                        [disabled]="tool.control.readOnly || tool.control.disabled"
                        [ngStyle]="tool.control.styles.style"
                        [ngClass]="tool.control.styles.classes"
                        [matMenuTriggerFor]="dropdownMenuOne"
                        [matTooltip]="tool.control.tooltip"
                        matTooltipClass="datex-control-tooltip">
                  <div class="button-label">
                    <div *ngIf="tool.control.icon"
                          class="button-icon">
                      <i data-cy="splitbutton-icon" class="icon {{tool.control.icon}}"></i>
                    </div>
                    <div data-cy="splitbutton-label" class="button-text">{{tool.control.label}}</div>
                    <div class="button-icon splitbutton-drop-icon">
                      <i data-cy="splitbutton-icon" class="icon icon-ic_fluent_chevron_down_20_regular"></i>
                    </div>
                  </div>
                </button>
                <mat-menu #dropdownMenuOne="matMenu" class="options-menu splitbutton-menu">
                  <div data-cy="splitbutton-options">
                    <div *ngIf="!tool.control.buttons.manage_container_types.removed" 
                        mat-menu-item 
                        class="splitbutton-item-container">
                      <button mat-button
                              data-cy="splitbutton-sub-item"
                              class="datex-button splitbutton-sub-item" 
                              [disabled]="tool.control.buttons.manage_container_types.readOnly || tool.control.buttons.manage_container_types.disabled"
                              [ngStyle]="tool.control.buttons.manage_container_types.styles.style"
                              [ngClass]="tool.control.buttons.manage_container_types.styles.classes"
                              [matTooltip]="tool.control.buttons.manage_container_types.tooltip"
                              matTooltipClass="datex-control-tooltip"
                              (click)="on_manage_container_types_clicked($event)">
                        <div class="button-label">
                          <div *ngIf="tool.control.buttons.manage_container_types.icon"
                              class="button-icon">
                            <i data-cy="splitbutton-sub-item-icon" class="icon {{tool.control.buttons.manage_container_types.icon}}"></i>
                          </div>
                          <div data-cy="splitbutton-sub-item-label"
                              class="button-text">{{tool.control.buttons.manage_container_types.label}}</div>
                        </div>
                      </button>
                    </div>
                    <div *ngIf="!tool.control.buttons.manage_reason_codes.removed" 
                        mat-menu-item 
                        class="splitbutton-item-container">
                      <button mat-button
                              data-cy="splitbutton-sub-item"
                              class="datex-button splitbutton-sub-item" 
                              [disabled]="tool.control.buttons.manage_reason_codes.readOnly || tool.control.buttons.manage_reason_codes.disabled"
                              [ngStyle]="tool.control.buttons.manage_reason_codes.styles.style"
                              [ngClass]="tool.control.buttons.manage_reason_codes.styles.classes"
                              [matTooltip]="tool.control.buttons.manage_reason_codes.tooltip"
                              matTooltipClass="datex-control-tooltip"
                              (click)="on_manage_reason_codes_clicked($event)">
                        <div class="button-label">
                          <div *ngIf="tool.control.buttons.manage_reason_codes.icon"
                              class="button-icon">
                            <i data-cy="splitbutton-sub-item-icon" class="icon {{tool.control.buttons.manage_reason_codes.icon}}"></i>
                          </div>
                          <div data-cy="splitbutton-sub-item-label"
                              class="button-text">{{tool.control.buttons.manage_reason_codes.label}}</div>
                        </div>
                      </button>
                    </div>
                    <div *ngIf="!tool.control.buttons.inventory_snapshot_rules.removed" 
                        mat-menu-item 
                        class="splitbutton-item-container">
                      <button mat-button
                              data-cy="splitbutton-sub-item"
                              class="datex-button splitbutton-sub-item" 
                              [disabled]="tool.control.buttons.inventory_snapshot_rules.readOnly || tool.control.buttons.inventory_snapshot_rules.disabled"
                              [ngStyle]="tool.control.buttons.inventory_snapshot_rules.styles.style"
                              [ngClass]="tool.control.buttons.inventory_snapshot_rules.styles.classes"
                              [matTooltip]="tool.control.buttons.inventory_snapshot_rules.tooltip"
                              matTooltipClass="datex-control-tooltip"
                              (click)="on_inventory_snapshot_rules_clicked($event)">
                        <div class="button-label">
                          <div *ngIf="tool.control.buttons.inventory_snapshot_rules.icon"
                              class="button-icon">
                            <i data-cy="splitbutton-sub-item-icon" class="icon {{tool.control.buttons.inventory_snapshot_rules.icon}}"></i>
                          </div>
                          <div data-cy="splitbutton-sub-item-label"
                              class="button-text">{{tool.control.buttons.inventory_snapshot_rules.label}}</div>
                        </div>
                      </button>
                    </div>
                  </div>
                </mat-menu>
                </ng-container>
              </ng-template>
          </app-toolbar>
      </div>
      <ng-content></ng-content>
    </div>

  <div class="blade-content">
    <div class="datex-hub">
      <ng-container
                    *ngIf="initialized ">
        <div class="hubdata">
          <h1 class="hubname" *ngIf="!showInDialog">{{hubTitle}}</h1>
          <h6 class="hubdesc">{{hubDescription}}</h6>
          <div class="hub-filters">
            <div class="fieldsetsGroup">
              <div [formGroup]="formGroup"
                   class="formdata">
                <div data-cy="fieldset-id-newGroup1"
                     *ngIf="!filtersets.newGroup1.hidden && !filtersets.newGroup1.removed"
                     class="fieldset-container">
                  <div class="fieldsetsContainer"
                       [ngClass]="{'collapsible': filtersets.newGroup1.collapsible }">
                    <div *ngIf="!filtersets.newGroup1.hideTitle"
                         data-cy="fieldset-title"
                         class="fieldsetsTitle"
                         (click)="filtersets.newGroup1.toggle()">
                      <span class="fieldsetsTitle-text">
                      {{filtersets.newGroup1.label}}
                      </span>
                      <i data-cy="fieldset-toggle"
                         *ngIf="filtersets.newGroup1.collapsible"
                         class="icon"
                         [ngClass]="{'icon-ic_fluent_chevron_down_20_filled': !filtersets.newGroup1.expanded, 'icon-ic_fluent_chevron_up_20_filled': filtersets.newGroup1.expanded }"></i>
                    </div>
                    <div data-cy="fieldset-group"
                         *ngIf="filtersets.newGroup1.expanded"
                         class="fieldsetsGroup">
                            <div data-cy="field-id-owner" *ngIf="!filters.owner.hidden && !filters.owner.removed" 
                                  class="field-container standard {{filters.owner.invalid ? 'invalid' : ''}} {{filters.owner.control.disabled ? 'field-container-disabled' : ''}}"
                                  [ngStyle]="filters.owner.styles.style"
                                  [ngClass]="filters.owner.styles.classes">
                              <div class="label-container"
                                   [matTooltip]="filters.owner.label + (filters.owner.required ? ' (required)' : '')"
                                   matTooltipClass="datex-control-tooltip">
                                <label data-cy="field-label" class="datex-label">{{filters.owner.label}}<span *ngIf="filters.owner.required" class="required-asterisk">*</span>
                                </label>
                              </div>
                              <Owners-owners_dd_single 
                                  data-cy="selector"
                                  [type]="filters.owner.control.type"
                                  formControlName="owner"
                                  (displayTextChange)="filters.owner.control.displayText=$event"
                                  [placeholder]="filters.owner.control.placeholder"
                                  [styles]="filters.owner.control.styles"
                                  [tooltip]="filters.owner.control.tooltip"
                                [statusId]="$fields_owner_selector_inParams_statusId"
                                [projectId]="$fields_owner_selector_inParams_projectId"
                              >
                              </Owners-owners_dd_single>
                              <ng-container *ngIf="filters.owner.invalid">
                                <ng-container *ngFor="let error of filters.owner.errors">
                                  <span class="invalid-message">
                                    {{error}}
                                  </span>
                                </ng-container>
                              </ng-container>
                            </div>              <div data-cy="field-id-project" *ngIf="!filters.project.hidden && !filters.project.removed" 
                                  class="field-container standard {{filters.project.invalid ? 'invalid' : ''}} {{filters.project.control.disabled ? 'field-container-disabled' : ''}}"
                                  [ngStyle]="filters.project.styles.style"
                                  [ngClass]="filters.project.styles.classes">
                              <div class="label-container"
                                   [matTooltip]="filters.project.label + (filters.project.required ? ' (required)' : '')"
                                   matTooltipClass="datex-control-tooltip">
                                <label data-cy="field-label" class="datex-label">{{filters.project.label}}<span *ngIf="filters.project.required" class="required-asterisk">*</span>
                                </label>
                              </div>
                              <Owners-projects_dd_single 
                                  data-cy="selector"
                                  [type]="filters.project.control.type"
                                  formControlName="project"
                                  (displayTextChange)="filters.project.control.displayText=$event"
                                  [placeholder]="filters.project.control.placeholder"
                                  [styles]="filters.project.control.styles"
                                  [tooltip]="filters.project.control.tooltip"
                                [statusId]="$fields_project_selector_inParams_statusId"
                                [ownerId]="$fields_project_selector_inParams_ownerId"
                              >
                              </Owners-projects_dd_single>
                              <ng-container *ngIf="filters.project.invalid">
                                <ng-container *ngFor="let error of filters.project.errors">
                                  <span class="invalid-message">
                                    {{error}}
                                  </span>
                                </ng-container>
                              </ng-container>
                            </div>              <div data-cy="field-id-materials" *ngIf="!filters.materials.hidden && !filters.materials.removed" 
                                  class="field-container standard {{filters.materials.invalid ? 'invalid' : ''}} {{filters.materials.control.disabled ? 'field-container-disabled' : ''}}"
                                  [ngStyle]="filters.materials.styles.style"
                                  [ngClass]="filters.materials.styles.classes">
                              <div class="label-container"
                                   [matTooltip]="filters.materials.label + (filters.materials.required ? ' (required)' : '')"
                                   matTooltipClass="datex-control-tooltip">
                                <label data-cy="field-label" class="datex-label">{{filters.materials.label}}<span *ngIf="filters.materials.required" class="required-asterisk">*</span>
                                </label>
                              </div>
                              <Materials-materials_by_project_dd_multi 
                                  data-cy="selector-multi"
                                  [type]="filters.materials.control.type"
                                  formControlName="materials"
                                  (displayTextChange)="filters.materials.control.displayText=$event"
                                  [placeholder]="filters.materials.control.placeholder"
                                  [styles]="filters.materials.control.styles"
                                  [tooltip]="filters.materials.control.tooltip"
                                [projectId]="$fields_materials_selector_inParams_projectId"
                              >
                              </Materials-materials_by_project_dd_multi>
                              <ng-container *ngIf="filters.materials.invalid">
                                <ng-container *ngFor="let error of filters.materials.errors">
                                  <span class="invalid-message">
                                    {{error}}
                                  </span>
                                </ng-container>
                              </ng-container>
                            </div>              <div data-cy="field-id-warehouse" *ngIf="!filters.warehouse.hidden && !filters.warehouse.removed" 
                                  class="field-container standard {{filters.warehouse.invalid ? 'invalid' : ''}} {{filters.warehouse.control.disabled ? 'field-container-disabled' : ''}}"
                                  [ngStyle]="filters.warehouse.styles.style"
                                  [ngClass]="filters.warehouse.styles.classes">
                              <div class="label-container"
                                   [matTooltip]="filters.warehouse.label + (filters.warehouse.required ? ' (required)' : '')"
                                   matTooltipClass="datex-control-tooltip">
                                <label data-cy="field-label" class="datex-label">{{filters.warehouse.label}}<span *ngIf="filters.warehouse.required" class="required-asterisk">*</span>
                                </label>
                              </div>
                              <Locations-warehouses_dd_single 
                                  data-cy="selector"
                                  [type]="filters.warehouse.control.type"
                                  formControlName="warehouse"
                                  (displayTextChange)="filters.warehouse.control.displayText=$event"
                                  [placeholder]="filters.warehouse.control.placeholder"
                                  [styles]="filters.warehouse.control.styles"
                                  [tooltip]="filters.warehouse.control.tooltip"
                              >
                              </Locations-warehouses_dd_single>
                              <ng-container *ngIf="filters.warehouse.invalid">
                                <ng-container *ngFor="let error of filters.warehouse.errors">
                                  <span class="invalid-message">
                                    {{error}}
                                  </span>
                                </ng-container>
                              </ng-container>
                            </div>            </div>
              
                          <div class="fieldset-details" *ngIf="!filtersets.newGroup1.expanded">
              
              
                          </div>
                        </div>
                      </div>
                <div data-cy="fieldset-id-newGroup2"
                     *ngIf="!filtersets.newGroup2.hidden && !filtersets.newGroup2.removed"
                     class="fieldset-container">
                  <div class="fieldsetsContainer"
                       [ngClass]="{'collapsible': filtersets.newGroup2.collapsible }">
                    <div *ngIf="!filtersets.newGroup2.hideTitle"
                         data-cy="fieldset-title"
                         class="fieldsetsTitle"
                         (click)="filtersets.newGroup2.toggle()">
                      <span class="fieldsetsTitle-text">
                      {{filtersets.newGroup2.label}}
                      </span>
                      <i data-cy="fieldset-toggle"
                         *ngIf="filtersets.newGroup2.collapsible"
                         class="icon"
                         [ngClass]="{'icon-ic_fluent_chevron_down_20_filled': !filtersets.newGroup2.expanded, 'icon-ic_fluent_chevron_up_20_filled': filtersets.newGroup2.expanded }"></i>
                    </div>
                    <div data-cy="fieldset-group"
                         *ngIf="filtersets.newGroup2.expanded"
                         class="fieldsetsGroup">
                            <div data-cy="field-id-inventory_type" *ngIf="!filters.inventory_type.hidden && !filters.inventory_type.removed" 
                                  class="field-container double {{filters.inventory_type.invalid ? 'invalid' : ''}} {{filters.inventory_type.control.disabled ? 'field-container-disabled' : ''}}"
                                  [ngStyle]="filters.inventory_type.styles.style"
                                  [ngClass]="filters.inventory_type.styles.classes">
                              <div class="label-container"
                                   [matTooltip]="filters.inventory_type.label + (filters.inventory_type.required ? ' (required)' : '')"
                                   matTooltipClass="datex-control-tooltip">
                                <label data-cy="field-label" class="datex-label">{{filters.inventory_type.label}}<span *ngIf="filters.inventory_type.required" class="required-asterisk">*</span>
                                </label>
                              </div>
                              <Inventory-inventory_aggregation_dd_single 
                                  data-cy="selector"
                                  [type]="filters.inventory_type.control.type"
                                  formControlName="inventory_type"
                                  (displayTextChange)="filters.inventory_type.control.displayText=$event"
                                  [placeholder]="filters.inventory_type.control.placeholder"
                                  [styles]="filters.inventory_type.control.styles"
                                  [tooltip]="filters.inventory_type.control.tooltip"
                              >
                              </Inventory-inventory_aggregation_dd_single>
                              <ng-container *ngIf="filters.inventory_type.invalid">
                                <ng-container *ngFor="let error of filters.inventory_type.errors">
                                  <span class="invalid-message">
                                    {{error}}
                                  </span>
                                </ng-container>
                              </ng-container>
                            </div>              <div data-cy="field-id-inventory_date" *ngIf="!filters.inventory_date.hidden && !filters.inventory_date.removed" 
                                  class="field-container standard {{filters.inventory_date.invalid ? 'invalid' : ''}} {{filters.inventory_date.control.disabled ? 'field-container-disabled' : ''}}"
                                  [ngStyle]="filters.inventory_date.styles.style"
                                  [ngClass]="filters.inventory_date.styles.classes">
                              <div class="label-container"
                                   [matTooltip]="filters.inventory_date.label + (filters.inventory_date.required ? ' (required)' : '')"
                                   matTooltipClass="datex-control-tooltip">
                                <label data-cy="field-label" class="datex-label">{{filters.inventory_date.label}}<span *ngIf="filters.inventory_date.required" class="required-asterisk">*</span>
                                </label>
                              </div>
                              <app-datebox 
                                  data-cy="dateBox"
                                  formControlName="inventory_date"
                                  [format]="filters.inventory_date.control.format"
                                  [mode]="filters.inventory_date.control.mode"
                                  [ngStyle]="filters.inventory_date.control.styles.style"
                                  [ngClass]="filters.inventory_date.control.styles.classes"
                                  [tooltip]="filters.inventory_date.control.tooltip">
                              </app-datebox>
                              <ng-container *ngIf="filters.inventory_date.invalid">
                                <ng-container *ngFor="let error of filters.inventory_date.errors">
                                  <span class="invalid-message">
                                    {{error}}
                                  </span>
                                </ng-container>
                              </ng-container>
                            </div>            </div>
              
                          <div class="fieldset-details" *ngIf="!filtersets.newGroup2.expanded">
              
              
                          </div>
                        </div>
                      </div>
                    </div>
            </div>
          </div>
        </div>

        <div class="widgets">
          <div *ngIf="!widgets.total_available_amount_widget.hidden && !widgets.total_available_amount_widget.removed" class="widget-container">
            <Inventory-total_available_amount_widget
            #$widgets_total_available_amount_widget 
              [ownerId]="$widgets_total_available_amount_widget_inParams_ownerId"
              [projectId]="$widgets_total_available_amount_widget_inParams_projectId"
              [materialIds]="$widgets_total_available_amount_widget_inParams_materialIds"
              [warehouseId]="$widgets_total_available_amount_widget_inParams_warehouseId"
            ($refreshEvent)="refresh(false, false, '$widgets_total_available_amount_widget')"
            >
            </Inventory-total_available_amount_widget>
          </div>
          <div *ngIf="!widgets.total_packaged_amount_widget.hidden && !widgets.total_packaged_amount_widget.removed" class="widget-container">
            <Inventory-total_packaged_amount_widget
            #$widgets_total_packaged_amount_widget 
              [warehouseId]="$widgets_total_packaged_amount_widget_inParams_warehouseId"
              [ownerId]="$widgets_total_packaged_amount_widget_inParams_ownerId"
              [projectId]="$widgets_total_packaged_amount_widget_inParams_projectId"
              [materialIds]="$widgets_total_packaged_amount_widget_inParams_materialIds"
            ($refreshEvent)="refresh(false, false, '$widgets_total_packaged_amount_widget')"
            >
            </Inventory-total_packaged_amount_widget>
          </div>
        </div>

        <div class="datex-tabcontrol" *ngIf="!this.rootTabGroup.allTabsHidden">
          <div class="tab-container">
            <div *ngIf="tabs.inventory_by_location.hasTabToShow" class="tab" data-cy="tab-inventory_by_location">
              <h2 [className]="tabs.inventory_by_location.active? 'active': ''" (click)="tabs.inventory_by_location.activate()">{{tabs.inventory_by_location.title}}</h2>
            </div>
            <div *ngIf="tabs.inventory_by_lp.hasTabToShow" class="tab" data-cy="tab-inventory_by_lp">
              <h2 [className]="tabs.inventory_by_lp.active? 'active': ''" (click)="tabs.inventory_by_lp.activate()">{{tabs.inventory_by_lp.title}}</h2>
            </div>
            <div *ngIf="tabs.inventory_by_lot.hasTabToShow" class="tab" data-cy="tab-inventory_by_lot">
              <h2 [className]="tabs.inventory_by_lot.active? 'active': ''" (click)="tabs.inventory_by_lot.activate()">{{tabs.inventory_by_lot.title}}</h2>
            </div>
            <div *ngIf="tabs.inventory_by_material.hasTabToShow" class="tab" data-cy="tab-inventory_by_material">
              <h2 [className]="tabs.inventory_by_material.active? 'active': ''" (click)="tabs.inventory_by_material.activate()">{{tabs.inventory_by_material.title}}</h2>
            </div>
            <div *ngIf="tabs.inventory_by_licenseplate_snapshot.hasTabToShow" class="tab" data-cy="tab-inventory_by_licenseplate_snapshot">
              <h2 [className]="tabs.inventory_by_licenseplate_snapshot.active? 'active': ''" (click)="tabs.inventory_by_licenseplate_snapshot.activate()">{{tabs.inventory_by_licenseplate_snapshot.title}}</h2>
            </div>
            <div *ngIf="tabs.inventory_by_lot_snapshot.hasTabToShow" class="tab" data-cy="tab-inventory_by_lot_snapshot">
              <h2 [className]="tabs.inventory_by_lot_snapshot.active? 'active': ''" (click)="tabs.inventory_by_lot_snapshot.activate()">{{tabs.inventory_by_lot_snapshot.title}}</h2>
            </div>
            <div *ngIf="tabs.inventory_by_material_snapshot.hasTabToShow" class="tab" data-cy="tab-inventory_by_material_snapshot">
              <h2 [className]="tabs.inventory_by_material_snapshot.active? 'active': ''" (click)="tabs.inventory_by_material_snapshot.activate()">{{tabs.inventory_by_material_snapshot.title}}</h2>
            </div>
            <div *ngIf="tabs.tasks.hasTabToShow" class="tab" data-cy="tab-tasks">
              <h2 [className]="tabs.tasks.active? 'active': ''" (click)="tabs.tasks.activate()">{{tabs.tasks.title}}</h2>
            </div>
          </div>
        
              <FootprintManager-inventory_location_grid *ngIf="tabs.inventory_by_location.active"
              #$tabs_inventory_by_location
              [ownerId]="$tabs_inventory_by_location_inventory_location_grid_inParams_ownerId"
              [projectId]="$tabs_inventory_by_location_inventory_location_grid_inParams_projectId"
              [warehouseId]="$tabs_inventory_by_location_inventory_location_grid_inParams_warehouseId"
              [materialIds]="$tabs_inventory_by_location_inventory_location_grid_inParams_materialIds"
              ($refreshEvent)="refresh(false, false, '$tabs_inventory_by_location')">
              </FootprintManager-inventory_location_grid>
              <FootprintManager-inventory_licenseplate_grid *ngIf="tabs.inventory_by_lp.active"
              #$tabs_inventory_by_lp
              [ownerId]="$tabs_inventory_by_lp_inventory_licenseplate_grid_inParams_ownerId"
              [projectId]="$tabs_inventory_by_lp_inventory_licenseplate_grid_inParams_projectId"
              [warehouseId]="$tabs_inventory_by_lp_inventory_licenseplate_grid_inParams_warehouseId"
              [materialIds]="$tabs_inventory_by_lp_inventory_licenseplate_grid_inParams_materialIds"
              ($refreshEvent)="refresh(false, false, '$tabs_inventory_by_lp')">
              </FootprintManager-inventory_licenseplate_grid>
              <FootprintManager-inventory_lot_grid *ngIf="tabs.inventory_by_lot.active"
              #$tabs_inventory_by_lot
              [ownerId]="$tabs_inventory_by_lot_inventory_lot_grid_inParams_ownerId"
              [projectId]="$tabs_inventory_by_lot_inventory_lot_grid_inParams_projectId"
              [warehouseId]="$tabs_inventory_by_lot_inventory_lot_grid_inParams_warehouseId"
              [materialIds]="$tabs_inventory_by_lot_inventory_lot_grid_inParams_materialIds"
              ($refreshEvent)="refresh(false, false, '$tabs_inventory_by_lot')">
              </FootprintManager-inventory_lot_grid>
              <FootprintManager-inventory_material_grid *ngIf="tabs.inventory_by_material.active"
              #$tabs_inventory_by_material
              [ownerId]="$tabs_inventory_by_material_inventory_material_grid_inParams_ownerId"
              [projectId]="$tabs_inventory_by_material_inventory_material_grid_inParams_projectId"
              [warehouseId]="$tabs_inventory_by_material_inventory_material_grid_inParams_warehouseId"
              [materialIds]="$tabs_inventory_by_material_inventory_material_grid_inParams_materialIds"
              ($refreshEvent)="refresh(false, false, '$tabs_inventory_by_material')">
              </FootprintManager-inventory_material_grid>
              <FootprintManager-inventory_licenseplate_snapshot_grid *ngIf="tabs.inventory_by_licenseplate_snapshot.active"
              #$tabs_inventory_by_licenseplate_snapshot
              [captureDate]="$tabs_inventory_by_licenseplate_snapshot_inventory_licenseplate_snapshot_grid_inParams_captureDate"
              [projectId]="$tabs_inventory_by_licenseplate_snapshot_inventory_licenseplate_snapshot_grid_inParams_projectId"
              [warehouseId]="$tabs_inventory_by_licenseplate_snapshot_inventory_licenseplate_snapshot_grid_inParams_warehouseId"
              [materialIds]="$tabs_inventory_by_licenseplate_snapshot_inventory_licenseplate_snapshot_grid_inParams_materialIds"
              ($refreshEvent)="refresh(false, false, '$tabs_inventory_by_licenseplate_snapshot')">
              </FootprintManager-inventory_licenseplate_snapshot_grid>
              <FootprintManager-inventory_lot_snapshot_grid *ngIf="tabs.inventory_by_lot_snapshot.active"
              #$tabs_inventory_by_lot_snapshot
              [captureDate]="$tabs_inventory_by_lot_snapshot_inventory_lot_snapshot_grid_inParams_captureDate"
              [projectId]="$tabs_inventory_by_lot_snapshot_inventory_lot_snapshot_grid_inParams_projectId"
              [warehouseId]="$tabs_inventory_by_lot_snapshot_inventory_lot_snapshot_grid_inParams_warehouseId"
              [materialIds]="$tabs_inventory_by_lot_snapshot_inventory_lot_snapshot_grid_inParams_materialIds"
              ($refreshEvent)="refresh(false, false, '$tabs_inventory_by_lot_snapshot')">
              </FootprintManager-inventory_lot_snapshot_grid>
              <FootprintManager-inventory_material_snapshot_grid *ngIf="tabs.inventory_by_material_snapshot.active"
              #$tabs_inventory_by_material_snapshot
              [captureDate]="$tabs_inventory_by_material_snapshot_inventory_material_snapshot_grid_inParams_captureDate"
              [projectId]="$tabs_inventory_by_material_snapshot_inventory_material_snapshot_grid_inParams_projectId"
              [warehouseId]="$tabs_inventory_by_material_snapshot_inventory_material_snapshot_grid_inParams_warehouseId"
              [materialIds]="$tabs_inventory_by_material_snapshot_inventory_material_snapshot_grid_inParams_materialIds"
              ($refreshEvent)="refresh(false, false, '$tabs_inventory_by_material_snapshot')">
              </FootprintManager-inventory_material_snapshot_grid>
              <FootprintManager-inventory_tasks_grid *ngIf="tabs.tasks.active"
              #$tabs_tasks
              [materialIds]="$tabs_tasks_inventory_tasks_grid_inParams_materialIds"
              [projectId]="$tabs_tasks_inventory_tasks_grid_inParams_projectId"
              [ownerId]="$tabs_tasks_inventory_tasks_grid_inParams_ownerId"
              [warehouseIds]="$tabs_tasks_inventory_tasks_grid_inParams_warehouseIds"
              ($refreshEvent)="refresh(false, false, '$tabs_tasks')">
              </FootprintManager-inventory_tasks_grid>
        </div>

      </ng-container>
    </div>
  </div>
</div>